// extracted by mini-css-extract-plugin
export default {"primary":"#0d54ff","primary80":"#1a2e61","primary100":"#131a35","secondary":"#f96449","tertiary":"#f5ede2","tertiary20":"#fef9ef","tertiary60":"#d4cdc3"};